const Constants = {
  // baseURL: "http://localhost:5000",
  baseURL: "https://contact-manager-backend-1123.herokuapp.com",
};

export default Constants;
